import { PTR_LENGTH } from "constants/products";

export const numValidator = (value) =>
  !value
    ? 'Numéro de produit requis'
    : value.length !== PTR_LENGTH || value < 0
      ? `Numéro de produit à ${PTR_LENGTH} caractères nécéssaire`
      : '';

export const required = (value, lib) => {
  return (value ? '' : lib + ' est requis.');
};

export const requiredDateGreater = (value, reference, libRequired, libReference) => {
  if (!reference)
    return '';

  if (value < reference)
    return (`${libRequired} doit être supérieur ou égal à ${libReference}`);

  return '';
};

export const requiredDateLower = (value, reference, libRequired, libReference) => {
  if (!reference)
    return '';

  if (value > reference)
    return (`${libRequired} doit être inférieur ou égal à ${libReference}`);

  return '';
};

export const requiredNumber = (value, lib) => {
  return value || value === 0 ? '' : lib + ' est requis.';
};

export const requiredArray = (value, lib) =>
  value !== undefined && value.length > 0 ? '' : lib + ' est requis.';

export const isAuthorizedCharacter = (value) => {
  const regex = /^[a-z0-9_-]+$/i;
  if (!regex.test(value))
    return "Le code doit uniquement contenir des lettres, des chiffres ou un des caractères suivants: _ -";

  return "";
};
